export default __webpack_public_path__ + "static/media/7 march.ded333ab.png";